import { SeoLinksProps } from '../components/molecules/seo-links/seo-links.props';

export const linkSectionsMock: SeoLinksProps['linkSections'] = [
    {
        type: 'mountains',
        title: 'Góry',
        tags: [
            {
                name: 'Karpacz noclegi',
                url: '/noclegi/karpacz/',
            },
            {
                name: 'Zakopane noclegi',
                url: '/noclegi/zakopane/',
            },
        ],
    },
    {
        type: 'seaside',
        title: 'Morze',
        tags: [
            {
                name: 'Gdańsk noclegi',
                url: '/noclegi/gdansk/',
            },
            {
                name: 'Sopot noclegi',
                url: '/noclegi/sopot/',
            },
        ],
    },
    {
        type: 'lakes',
        title: 'Jeziora',
        tags: [
            {
                name: 'Olsztyn noclegi',
                url: '/noclegi/olsztyn/',
            },
            {
                name: 'Okuninka noclegi',
                url: '/noclegi/okuninka/',
            },
        ],
    },
    {
        type: 'other',
        title: 'Pozostałe',
        tags: [
            {
                name: 'Kraków noclegi',
                url: '/noclegi/krakow/',
            },
            {
                name: 'Lublin noclegi',
                url: '/noclegi/lublin/',
            },
        ],
    },
];
